import { styled } from "@mui/material/styles";

const NochatMain = styled("div")(({ theme }) => ({
  width: "70%",
  display: "flex",
  height: "90vh",
  background: "#E1E1E1",
  justifyContent: "center",
  alignItems: "center",
  fontStyle: "normal",
  fontWeight: 600,
  fontSize: "16px",
  lineHeight: "24px",
  color: "#0B0B0B",
  fontFamily: theme.typography.fontFamily,
}));

export { NochatMain };
